import { Link } from 'react-router-dom';
import { ShieldExclamationIcon } from '@heroicons/react/24/outline';

export default function Unauthorized() {
  return (
    <div className="mx-auto mt-16 max-w-xl rounded-2xl border border-amber-200 bg-white p-8 text-center shadow-sm dark:border-amber-900 dark:bg-gray-800">
      <ShieldExclamationIcon className="mx-auto h-12 w-12 text-amber-500" />
      <h1 className="mt-4 text-2xl font-bold">You do not have access to this page</h1>
      <p className="mt-2 text-gray-600 dark:text-gray-300">The page belongs to a different account role or organization.</p>
      <Link to="/" className="mt-6 inline-flex rounded-xl bg-blue-600 px-4 py-2.5 font-semibold text-white hover:bg-blue-700">Return to your dashboard</Link>
    </div>
  );
}
